import "../style/footer.css";
import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Designed and built with React by Kim Nguyen. © 2026</p>
    </footer>
  );
};

export default Footer;
